<template>
  <div class="switcher">
    <div class="switcher__label switcher__label--before" @click="toggle" v-if="labelBefore" v-text="labelBefore" />
    <div class="switcher__handler" @click="toggle" :class="{'switcher__handler--active': value}">
      <div class="switch"></div>
    </div>
    <div class="switcher__label switcher__label--after" @click="toggle" v-if="labelAfter" v-text="labelAfter" />
  </div>
</template>

<script>
    export default {
        name: "NccSwitcher",
        props: {
            labelBefore: {
                type: String,
                default: null
            },
            labelAfter: {
                type: String,
                default: null
            },
            value: false
        },
        methods: {
          toggle() {
            this.$emit('input', !this.value);
          }
        }
    }
</script>

<style lang="scss" scoped>
  @import './../../scss/base';

  .switcher {
    display: flex;
    flex-direction: row;
    padding: .5rem 0;
    border-bottom: 1px $gray-200 solid;
  }

  .switcher:first-child {
    border-top: 1px $gray-200 solid;
  }

  .switcher__label--before {
    display: none;
    margin-right: .5rem;
  }

  .switcher__label--after {
    margin-left: 2.5rem;
  }

  .switcher__handler {
    cursor: pointer;
    position: relative;
    width: 3rem;
    height: 1.5rem;
    border-radius: .75rem;
    background-color: #B1B1B1;
    margin-left: .5rem;

    .switch {
      left: 0;
      position: absolute;
      transition: 150ms left ease-in-out;
      width: 1.5rem;
      padding-top: 1.5rem;
      background: #575756;
      border-radius: .75rem;
    }

    .switcher__handler:hover {
      background: darken(#575756, 5);
    }
  }

  .switcher__handler--active {
    background-color: var(--primary);

    .switch {
      left: 50%;
    }
  }

  @media all and (min-width: 769px) {
    .switcher__label--before {
      display: block;
    }

    .switcher__label--after {
      margin-left: .5rem;
    }

    .switcher {
      padding: 0;
      border: 0 !important;
    }

    .switcher__handler {
      margin: 0;
    }
  }

</style>
